<script>
export default {
    methods: {
        async checkUploadBandwith(url, chunksToUpload = 20) {
            this.cancelled = false;
            this.abortController = new AbortController();
            this.uploading = true;
            this.uploadSuccess = false;
            this.uploadError = false;

            const formData = new FormData();

            formData.append('file', this.fakeData, 'fakeData');

            for (let i = 1; i <= chunksToUpload; i++) {
                if (this.cancelled) break;

                try {
                    const startTime = Date.now(); // Début du téléchargement

                    const response = await fetch(url, {
                        method: 'POST',
                        body: formData,
                        signal: this.abortController.signal
                    });

                    const endTime = Date.now(); // Fin du téléchargement

                    const duration = (endTime - startTime) / 1000; // Temps en secondes

                    const bitsReceived = this.size * 8; // En bits
                    const bandwidth = bitsReceived / (duration * 1_000_000); // Bande passante en Mbps

                    this.uploadSpeeds.push(bandwidth);
                    this.averageUploadSpeed = this.uploadSpeeds.reduce((partialSum, a) => partialSum + a, 0) / i;

                    this.uploadChart.data.labels.push('');
                    this.uploadChart.data.datasets[0].data.push(bandwidth.toFixed(2));
                    this.uploadChart.data.datasets[1].data.push(this.averageUploadSpeed.toFixed(2));
                    this.uploadChart.update();

                } catch (error) {
                    if (error.name === 'AbortError') break;
                    console.error(error);
                }

                await new Promise((resolve) =>
                    setTimeout(resolve, 500)
                );
            }

            if (!this.cancelled) {
                this.done = true;
                this.$emit('done');
            }
        },
        cancel() {
            this.cancelled = true;
            this.abortController?.abort();
        },
        reset() {
            this.cancel();
            this.done = false;
            this.cancelled = false;
            this.averageUploadSpeed = 0;
            this.uploadSpeeds = [];
            if (this.uploadChart) {
                this.uploadChart.data.labels = [];
                this.uploadChart.data.datasets[0].data = [];
                this.uploadChart.data.datasets[1].data = [];
                this.uploadChart.update();
            }
        }
    },
    data() {
        return {
            done: false,
            cancelled: false,
            abortController: null,
            averageUploadSpeed: 0,
            uploadSpeeds: [],
            // 500 Ko en fait car ingress limite à 1Mo
            size: 1024 * 500,
            fakeData: null,
            uploadChart: null,
            bandwidth: {
                labels: [],
                datasets: [
                    {
                        label: 'Hits',
                        // cubicInterpolationMode: 'monotone',
                        borderColor: "#8D1EB1",
                        // backgroundColor: "#FCD7B780",
                        borderDash: [5, 5],
                        // fill: true,
                    },
                    {
                        label: 'Average',
                        cubicInterpolationMode: 'monotone',
                        // tension: 0.1,
                        borderColor: "#8D1EB1",
                        backgroundColor: "#D1A5E080",
                        tension: 0.1,
                        fill: true,
                    }]
            }
        };
    },
    computed: {
        chartYMin() {
            return this.uploadChart?.scales?.y?.min;
        },
        chartYMax() {
            return this.uploadChart?.scales?.y?.max;
        },
        uploadtAnnotationBottom() {
            if (!this.uploadChart?.scales?.y) return 0;

            if(this.uploadAnnotationValue < this.uploadChart.scales.y.min)
            {
                return 0;
            }

            var h = this.uploadChart.scales.y.max - this.uploadChart.scales.y.min;

            var l = this.uploadAnnotationValue - this.uploadChart.scales.y.min;

            return Math.min(100, l * 100 / h);
        },
        status() {
            if (!this.done) {
                return 'pending';
            }
            else if (this.averageUploadSpeed > this.uploadAnnotationValue) {
                return 'ok';
            }
            else {
                return 'ko';
            }
        }
    },
    props: {
        uploadtAnnotationLabel:
        {
            default: 'Minimum required (6Mbps)'
        },
        uploadAnnotationValue:
        {
            default: 6
        },
        enabled:
        {
            default: false
        },
        url: {}
    },
    translate25Context: 'troubleshooting',
    watch: {
        enabled: function () {
            if (this.enabled) {
                this.checkUploadBandwith(this.url + '/upload');
            }
        }
    },
    mounted() {
        this.uploadChart = new Chart(
            this.$refs['uploadChart'],
            {
                type: 'line',
                data: this.bandwidth,
                options: {
                    animation: {
                        duration: 500, // durée en ms
                        easing: 'easeOutQuart' // autre exemple : 'linear', 'easeInOutQuad', etc.
                    },
                    plugins: {
                        legend: {
                            display: false,
                        }
                    },
                    scales: {
                        x: {
                            display: false,
                        },
                        y: {
                            display: false,
                            suggestedMin: 0
                        },
                    },
                    radius: 0,
                }
            }
        );

        this.$refs.legend.innerHTML = this.uploadChart.data.datasets.map(dataset => {

            const isDashed = dataset.borderDash ? true : false;
            return `
                <div style="margin-bottom: 4px; display: flex; align-items: center;">
                <span style="
                    width: 16px;
                    height: 16px;
                    ${isDashed ? `border: 3px dashed ${dataset.borderColor}; background: ${dataset.backgroundColor};` : `border: 3px solid ${dataset.borderColor}; background-color: ${dataset.backgroundColor};`}
                    display: inline-block;
                    margin-right: 8px;
                "></span>
                ${dataset.label}
                </div>
            `;
        }).join('');

        // On génère un gros data de this.size octets
        const data = new Uint8Array(this.size);

        // Remplir le tableau avec des données aléatoires (valeurs entre 0 et 255)
        for (let i = 0; i < this.size; i++) {
            data[i] = Math.floor(Math.random() * 256);
        }

        // Créer un Blob à partir de ce tableau d'octets
        this.fakeData = new Blob([data], { type: 'application/octet-stream' });

        if (this.enabled) {
            this.checkUploadBandwith(this.url + '/upload');
        }
    }
};
</script>

<template>
    <div class="troubleshooting-bandwith">

        <div class="troubleshooting-bandwith-title-and-value">
            <troubleshooting-page-status :status="status">
                <template #content>
                    <div class="troubleshooting-bandwith-title">{{ $vt('Upload') }}
                    </div>
                </template>
            </troubleshooting-page-status>
            <div class="troubleshooting-bandwith-value">{{ averageUploadSpeed.toFixed(2) }} Mbps</div>
        </div>

        <div class="troubleshooting-bandwith-chart">
            <!-- <div class="troubleshooting-bandwith-chart-y-min">{{ chartYMin }} Mbps</div>
            <div class="troubleshooting-bandwith-chart-y-max">{{ chartYMax }} Mbps</div> -->
            <div class="troubleshooting-bandwith-annotation" v-if="averageUploadSpeed != 0"
                :style="{ bottom: uploadtAnnotationBottom + '%' }">
                <div class="troubleshooting-bandwith-annotation-label">{{ $vt(uploadtAnnotationLabel) }}</div>
                <div class="troubleshooting-bandwith-annotation-line"></div>
            </div>
            <canvas ref="uploadChart"></canvas>
        </div>
        <div ref="legend" class="troubleshooting-bandwith-legend-container"></div>
        <f-hint type="negative" v-if="averageUploadSpeed != 0 && averageUploadSpeed < uploadAnnotationValue"
            icon="fa6-triangle-exclamation">
            <template #message>{{ $vt('Your upload speed does not meet the minimum requirement (6Mbps)') }}</template>
        </f-hint>
    </div>
</template>

<style lang="scss"></style>
